import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {EquipamentosModel} from "./equipamentos.model";
import {EquipamentosService} from './equipamentos.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-equipamentos-form',
  templateUrl: './equipamentos-form.component.html'
})
export class EquipamentosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  equipamento: EquipamentosModel = new EquipamentosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private equipamentosService: EquipamentosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_equipamento: [],
      descricao: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      calibracao: ['', [
        Validators.required
      ]],
      vencimento: ['', [
        Validators.required
      ]],
      numero_serie: ['', [
        Validators.maxLength(20)
      ]],
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_equipamento'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarEquipamento');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarEquipamento') : this.func.traduzir('front.cadastrarNovoEquipamento');
      }

      if (!id) {
        return;
      }

      this.equipamentosService.getById(id)
        .subscribe(
          json => {
            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }

            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarEquipamento')+': '+json.Payload[0].descricao;
            }else{
              this.title = this.func.traduzir('front.visualizarEquipamento')+': '+json.Payload[0].descricao;
            }
            this.equipamento = json.Payload[0]
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      values = this.equipamento;

    if (values.id_equipamento) {
      result = this.equipamentosService.editar(values, values.id_equipamento);
    } else {
      result = this.equipamentosService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'equipamentos']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/equipamentos/equipamentos-form.component.ts